import { Field, Label, ErrorMessage } from "V2.0/common/fieldset";
import { Input } from "V2.0/common/input";
import { Textarea } from "V2.0/common/textarea";
import Rules from "./Rules";

export default ConditionRuleForm;

function ConditionRuleForm(props) {
  const { formState, updateFormState, errors } = props;

  return (
    <div className="flex flex-col gap-y-8">
      <Field>
        <Label>Name *</Label>
        <Input
          type="text"
          value={formState.name}
          onChange={(e) => updateFormState("name", e.target.value)}
          invalid={!!errors.name}
        />
        {errors.name && <ErrorMessage>{errors.name}</ErrorMessage>}
      </Field>

      <Field>
        <Label>Description</Label>
        <Textarea
          rows={3}
          style={{ fontSize: "13px" }}
          value={formState.description}
          onChange={(e) => updateFormState("description", e.target.value)}
        />
      </Field>

      <div>
        <Rules
          rules={formState.rules}
          onUpdateRule={(rules) => updateFormState("rules", rules)}
        />
        {errors.rules && <ErrorMessage>{errors.rules}</ErrorMessage>}
      </div>
    </div>
  );
}
